import Layout from "../components/Common/Layouts";
import InsightComponent from "../components/Insight";

const Dashboard = () => {
  return (
    <Layout>
      <InsightComponent />
    </Layout>
  );
};

export default Dashboard;
